export const sessionResourceTooltipMessages = {
  expired: 'This resource has expired.',
  deleted: 'This resource is not available anymore.',
  accessibleToStudents: 'This resource is accessible to students. If you want to change this, click on the resource.',
  notAccessibleToStudents:
    'This resource is not accessible to students. If you want to change this, click on the resource.',
};
